// @purpose VIEW
// Invites / compare / sender-view island (M6.3/M6.4). Everything is server-rendered HTMX; this only
//  - copies an invite link ([data-copy]) and flips the button label for a moment;
//  - fires the client-side product events once per rendered fragment ([data-track]):
//    invite_sent (ready-to-send card), compare_accepted, compare_revoked, and the page views of /people/
//    (people_page_viewed) and /teams/ (teams_page_viewed). Schema-checked by track().
//  - on /people/, a tap on any link or button inside a choice card ([data-choice]) fires
//    people_choice_clicked {choice}; on /teams/, [data-teams-offer] fires teams_cta_clicked {offer}.
import { track } from "../track.js";

const PROPS = {
  invite_sent: (el) => ({ channel: el.dataset.channel || "", referral_code: el.dataset.referralCode || "" }),
  compare_accepted: (el) => ({ pair_id: el.dataset.pairId || "" }),
  compare_revoked: (el) => ({ who: el.dataset.who === "other" ? "other" : "self", pair_id: el.dataset.pairId || "" }),
  people_page_viewed: () => ({}),
  teams_page_viewed: () => ({}),
};

function fire(root) {
  const nodes = root?.querySelectorAll ? [root, ...root.querySelectorAll("[data-track]")] : [];
  for (const el of nodes) {
    const name = el.dataset?.track;
    if (!name || el.dataset.tracked || !PROPS[name]) continue;
    el.dataset.tracked = "1";
    track(name, PROPS[name](el));
  }
}

document.addEventListener("htmx:load", (e) => fire(e.detail.elt));
fire(document.body);

document.addEventListener("click", (e) => {
  const hit = e.target.closest?.("a, button");
  if (!hit) return;
  const card = hit.closest("[data-choice]");
  if (card) track("people_choice_clicked", { choice: card.dataset.choice === "group" ? "group" : "one" });
  const offer = hit.dataset.teamsOffer;
  if (offer) track("teams_cta_clicked", { offer: offer === "talk" ? "talk" : "free_box" });
});

document.addEventListener("click", async (e) => {
  const btn = e.target.closest?.("[data-copy]");
  if (!btn) return;
  const label = btn.textContent;
  try {
    await navigator.clipboard.writeText(btn.dataset.copy);
    btn.textContent = btn.dataset.copied || label;
    setTimeout(() => (btn.textContent = label), 1500);
  } catch {
    btn.previousElementSibling?.select?.();
  }
});
